/**
 * Limsa Header — PURE COLOR HOVER v3 (2026-04-18)
 * Slot machine KALDIRILDI (Batuhan direktifi: "etkileşim olmadıkça siyah,
 * hover'da pembe, iz olmayacak, çekince siyaha dön").
 *
 * Bu dosya:
 *   1. Önceki slot DOM wrap'larını TEMIZLER (unwrap) — "siyah iz" bug'ı giderir
 *   2. Active state'i sync eder (URL path eşleşmesi → is-active + aria-current)
 *   3. DOM wrap YAPMAZ — tüm hover efekti pure CSS ile
 */
(function () {
  'use strict';

  var SELECTORS = [
    '.dt-sc-nav-link',
    '.header__menu-item',
    '.header__inline-menu > li > a',
    '.header__inline-menu > li > details > summary',
    '.dt-nav a',
    '#AccessibleNav a'
  ].join(', ');

  /* Önceki slot wrap'ı unwrap et → sadece text geri gelsin */
  function unwrapSlot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.limsa-slot-wrap').forEach(function (wrap) {
      var orig = wrap.querySelector('.limsa-slot-orig');
      var text = orig ? orig.textContent : (wrap.textContent || '');
      var host = wrap.parentElement;
      if (!host) return;
      // Host'un diğer child'larını koru (svg caret vs)
      var keepChildren = Array.prototype.filter.call(host.childNodes, function (n) {
        return n !== wrap && !(n.nodeType === 3 && !n.textContent.trim());
      });
      host.innerHTML = '';
      host.appendChild(document.createTextNode(text));
      keepChildren.forEach(function (k) { host.appendChild(k); });
      host.classList.remove('limsa-slot-host');
    });
  }

  function activeSync() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll(SELECTORS).forEach(function (a) {
      try {
        var href = a.getAttribute('href') || '';
        if (!href) return;
        var u = new URL(href, window.location.origin);
        var p = u.pathname.replace(/\/+$/, '') || '/';
        if (p === path) {
          a.classList.add('is-active', 'limsa-is-active');
          a.setAttribute('aria-current', 'page');
          var li = a.closest('li');
          if (li) li.classList.add('active');
        }
      } catch (e) {}
    });
  }

  function run() {
    unwrapSlot(document);
    /* legacy dataset işaretlerini temizle */
    document.querySelectorAll('[data-limsa-slot-done]').forEach(function (el) {
      try { delete el.dataset.limsaSlotDone; } catch (e) {}
    });
    activeSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 3000);

  /* Dinamik DOM'a eklenen yeni nav'ları da temizle */
  try {
    var hdr = document.querySelector('header, .header, .header-wrapper, sticky-header, #AccessibleNav');
    if (hdr) {
      new MutationObserver(function () { run(); })
        .observe(hdr, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
